import * as Yup from 'yup'

export const RegisterSchema = (digit: number) =>
  Yup.object().shape({
    name: Yup.string()
      .min(2, 'register:Error.Name_Minimum')
      .required('register:Error.Name_Required'),
    companyName: Yup.string()
      .min(2, 'register:Error.Company_Minimum')
      .required('register:Error.Company_Required'),
    email: Yup.string()
      .email('register:Error.Email_Format')
      .required('register:Error.Email_Required'),
    phone: Yup.number()
      .typeError('register:Error.Phone_Format')
      .required('register:Error.Phone_Required')
      .test('len', 'register:Error.Phone_Format', async (val) => {
        if (val === undefined || val === null) return false
        console.log(val.toString().length, digit)
        return val.toString().length + digit > 10 && val.toString().length + digit < 16
      }),
    password: Yup.string()
      .min(8, 'register:Error.Password_Minimum')
      .required('register:Error.Password_Required'),
  })
